// src/lib/scrollDepth.js
// Fire a scroll_depth dataLayer event once each at 25/50/75/100% page depth,
// tagged with the active A/B variant so depth can be segmented per variant.

import { trackEvent } from './analytics';
import { getAbVariant } from './abTest';

const THRESHOLDS = [25, 50, 75, 100];

/**
 * Attach a passive scroll listener. Returns a cleanup function.
 * No-op (returns a noop cleanup) during prerender / SSR.
 */
export function initScrollDepth() {
  if (typeof window === 'undefined') return () => {};

  const fired = new Set();

  const onScroll = () => {
    const doc = document.documentElement;
    const scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    const pct = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
    for (const t of THRESHOLDS) {
      if (pct >= t && !fired.has(t)) {
        fired.add(t);
        trackEvent('scroll_depth', { scroll_percent: t, ab_variant: getAbVariant() });
      }
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll);
}
